var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-navbar",
        {
          attrs: { id: "header", type: "light", variant: "light", sticky: "" }
        },
        [
          _c("b-navbar-nav", [
            _c("h4", { staticClass: "mb-0" }, [_vm._v("Персонал")])
          ]),
          _vm._v(" "),
          _c(
            "b-navbar-nav",
            { staticClass: "ml-auto" },
            [
              _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "b-toggle",
                      rawName: "v-b-toggle.sidebar-fields",
                      modifiers: { "sidebar-fields": true }
                    }
                  ],
                  staticClass: "mr-2",
                  attrs: {
                    id: "table-settings",
                    size: "sm",
                    variant: "warning"
                  }
                },
                [_c("font-awesome-icon", { attrs: { icon: "cog" } })],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tooltip",
                {
                  attrs: {
                    target: "table-settings",
                    triggers: "hover",
                    variant: "warning",
                    noninteractive: ""
                  }
                },
                [_vm._v("\n        Колонки\n      ")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-navbar-nav",
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "auto" } },
                    [
                      _vm.canEditStaffs()
                        ? _c(
                            "b-btn",
                            {
                              staticClass: "ml-1",
                              attrs: {
                                size: "sm",
                                variant: "success",
                                disabled: _vm.isBusy
                              },
                              on: {
                                click: function($event) {
                                  return _vm.onCreate()
                                }
                              }
                            },
                            [
                              _vm.isBusy
                                ? _c("b-spinner", { attrs: { small: "" } })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("font-awesome-icon", {
                                staticClass: "mr-1",
                                attrs: { icon: "plus" }
                              }),
                              _vm._v("\n            Новый\n          ")
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "filters-drawer",
        {
          attrs: {
            query: _vm.filters.query,
            "is-busy": _vm.isBusy,
            "filter-tags": _vm.activeFilterTags
          },
          on: {
            "update:query": function($event) {
              return _vm.$set(_vm.filters, "query", $event)
            },
            "remove-tag": _vm.removeFilterTag,
            submit: _vm.onSearch,
            clear: _vm.onClearFilters
          }
        },
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c("label", { staticClass: "small text-muted" }, [
                _vm._v("Организация")
              ]),
              _vm._v(" "),
              _c("organization-select", {
                ref: "organization_select",
                attrs: {
                  id: "input-organization-select",
                  "initial-id": _vm.filters.organization_id
                },
                on: { onSelect: _vm.onSelectOrganization }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("b-table", {
        ref: "staffs",
        staticClass: "mb-0 text-small",
        attrs: {
          id: "staffs",
          selectable: "",
          "select-mode": "single",
          selectedVariant: "success",
          striped: "",
          small: "",
          responsive: "",
          "show-empty": "",
          "empty-text": _vm.$t("message.common.emptyTable"),
          busy: _vm.isBusy,
          items: _vm.items,
          fields: _vm.renderedFields,
          "no-provider-filtering": "",
          "no-provider-paging": "",
          "no-provider-sorting": "",
          "no-local-sorting": "",
          "sticky-header": "",
          "head-variant": "light"
        },
        on: {
          "sort-changed": _vm.sortChanged,
          "row-dblclicked": _vm.onRowClicked
        },
        scopedSlots: _vm._u([
          {
            key: "table-busy",
            fn: function() {
              return [
                _c(
                  "div",
                  { staticClass: "text-center text-success my-2" },
                  [
                    _c("b-spinner", { staticClass: "align-middle" }),
                    _vm._v(" "),
                    _c("strong", [_vm._v("Загрузка")])
                  ],
                  1
                )
              ]
            },
            proxy: true
          },
          {
            key: "cell(name)",
            fn: function(row) {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.getShortName(
                        row.item.surname,
                        row.item.name,
                        row.item.patronymic
                      )
                    ) +
                    "\n    "
                )
              ]
            }
          },
          {
            key: "cell(migration_entry_date)",
            fn: function(row) {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.formatTableDate(row.item.migration_entry_date)) +
                    "\n    "
                )
              ]
            }
          },
          {
            key: "cell(contract_add_date)",
            fn: function(row) {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.formatTableDate(row.item.contract_add_date)) +
                    "\n    "
                )
              ]
            }
          },
          {
            key: "cell(patent_issue_date)",
            fn: function(row) {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.formatTableDate(row.item.patent_issue_date)) +
                    "\n    "
                )
              ]
            }
          },
          {
            key: "cell(patent_expiration)",
            fn: function(row) {
              return [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.formatTableDate(row.item.patent_expiration)) +
                    "\n    "
                )
              ]
            }
          },
          {
            key: "cell(active)",
            fn: function(row) {
              return [
                !row.item.active
                  ? _c("font-awesome-icon", { attrs: { icon: "times" } })
                  : _vm._e(),
                _vm._v(" "),
                row.item.active
                  ? _c("font-awesome-icon", { attrs: { icon: "check" } })
                  : _vm._e()
              ]
            }
          },
          {
            key: "cell(action)",
            fn: function(row) {
              return [
                _c(
                  "b-btn",
                  {
                    attrs: { size: "sm", variant: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.onEdit(row.item)
                      }
                    }
                  },
                  [_c("font-awesome-icon", { attrs: { icon: "edit" } })],
                  1
                )
              ]
            }
          }
        ])
      }),
      _vm._v(" "),
      _c("pagination-footer", {
        attrs: { "total-rows": _vm.totalRows, "per-page": _vm.perPage },
        on: {
          "update:perPage": function($event) {
            _vm.perPage = $event
          },
          "update:per-page": function($event) {
            _vm.perPage = $event
          },
          "page-click": _vm.onPagination,
          "per-page-change": _vm.onPerPageChange
        }
      }),
      _vm._v(" "),
      _c("dynamic-tables", {
        attrs: {
          "storage-key": "staffs_columns",
          "sidebar-fields": "sidebar-fields",
          "fields-model": _vm.fields,
          fieldKey: "id"
        },
        on: {
          "update:fieldsModel": function($event) {
            _vm.fields = $event
          },
          "update:fields-model": function($event) {
            _vm.fields = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-21e0ea1c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21e0ea1c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Staff/Staffs.vue
// module id = null
// module chunks = 